import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=0aa92656&scoped=true"
import script from "./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue?vue&type=style&index=0&id=0aa92656&prod&scoped=scoped&lang=css"
import style1 from "./Details.vue?vue&type=style&index=1&id=0aa92656&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa92656",
  null
  
)

export default component.exports